import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 32" {...props}>
    <path d="M58.955.8a2.536 2.536 0 0 1 2.537 2.535 2.521 2.521 0 0 1-2.527 2.505 2.521 2.521 0 0 1-.01-5.04ZM13.053 5.997H7.976V.927h-2.9v5.07H0v2.898h5.075v5.073h2.9V8.895h5.078V5.997Z" />
    <path
      fillRule="evenodd"
      d="M28.935 24.802V12.727c0-3.697-2.425-5.823-6.92-5.83-4.355 0-7.09 1.978-8.089 5.25l3.897.982c.519-1.783 1.834-2.847 4.061-2.847 2.08 0 3.03.918 3.03 2.11 0 1.605-1.674 1.835-4.11 2.096l-.066.007c-3.134.342-7.124.777-7.124 5.26 0 3.319 2.137 5.31 5.757 5.31 2.34 0 4.307-.836 5.6-2.947v2.684h3.964Zm-4.031-8.312v1.407c0 2.356-2.013 3.781-4.566 3.781-1.703 0-2.72-.655-2.72-2.144 0-1.841 1.537-2.038 3.504-2.29l.132-.017c1.238-.124 2.46-.37 3.65-.737Z"
      clipRule="evenodd"
    />
    <path d="M35.617.8v24.002h-4.028V.8h4.028Z" />
    <path
      fillRule="evenodd"
      d="M42.467 9.897V7.23h-4.03V31.2h4.03v-9.342c.998 1.914 2.683 2.945 5.256 2.945 4.978 0 7.544-3.746 7.544-8.95 0-5.203-2.566-8.948-7.528-8.948-2.604 0-4.24 1.046-5.272 2.993Zm4.39.447c2.764 0 4.386 2.075 4.388 5.507-.002 3.44-1.622 5.524-4.388 5.524-2.768 0-4.389-2.104-4.389-5.531 0-3.427 1.623-5.5 4.389-5.5Zm4.388 5.507v.006-.013.007Z"
      clipRule="evenodd"
    />
    <path d="M56.957 7.229h4.028v17.573h-4.028z" />
    <path
      fillRule="evenodd"
      d="M77.986 24.802V12.727c0-3.697-2.425-5.823-6.929-5.823-4.355 0-7.09 1.978-8.089 5.25l3.897.982c.519-1.783 1.834-2.847 4.062-2.847 2.079 0 3.029.918 3.029 2.11 0 1.604-1.688 1.834-4.101 2.089l-.066.007c-3.135.342-7.124.777-7.124 5.26 0 3.319 2.137 5.31 5.757 5.31 2.34 0 4.307-.836 5.6-2.947v2.684h3.964Zm-4.032-8.312v1.407c0 2.356-2.012 3.781-4.568 3.781-1.702 0-2.719-.655-2.719-2.144 0-1.841 1.536-2.038 3.504-2.29l.132-.017a18.742 18.742 0 0 0 3.651-.737Z"
      clipRule="evenodd"
    />
    <path d="M84.668 7.23v2.7c.934-1.719 2.506-3.026 5.405-3.026 3.83 0 5.927 2.29 5.927 6.037v11.86h-4.028V14.25c0-2.356-1.016-3.746-3.226-3.746-2.588 0-4.078 1.88-4.078 4.334v9.956H80.64V7.229h4.028Z" />
  </svg>
);

export default SvgComponent;
